module.exports = __webpack_public_path__ + "90c45bab9b7820acd03d39b8ae7a4253.pdf";